export const DataResult = {
  getSuccessResponse(data = null) {
    if (data == null) {
      return {
        status: 'SUCCESS',
        message: null,
        content: data,
        msgKey: null,
        msgArgArr: null
      }
    } else {
      return {
        status: data.status || 'SUCCESS',
        message: data.message || null,
        content: data.content || data,
        msgKey: data.msgKey || null,
        msgArgArr: data.msgArgArr || []
      }
    }
  }
}

export function getParam(url, name) {
  const query = url.substring(url.indexOf('?') + 1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] === name) {
      return pair[1]
    }
  }
  return null
}

export class PageResponse {
  constructor(total, itemArr) {
    this.total = total
    this.itemArr = itemArr
  }
}
